var SpeechToText = {
	recognition: null,
	currentEl: null,
	recording: false,
	newRequest: null,

	init: function() {
		this.recognition = new webkitSpeechRecognition();
		this.recognition.continuous = true;
		this.recognition.interimResults = true;
	},

	trigger: function(el,id) {
		if(this.recording) {
			this.newRequest = el
			this.recognition.onend = this.checkWhenDone
			this.recognition.stop()
			this.recording = false
			$(el).removeClass('recording')
			window.wrL2eSound.stopAllSounds()
			window.wrL2eSound.playSound("end_recording" + "_speech_control" )
		} else {
			this.launchRecording(el,id)
			window.wrL2eSound.stopAllSounds()
			window.wrL2eSound.playSound("start_recording" + "_speech_control" )
		}
	},
	launchRecording: function(el,id) {
		this.recording = true
		this.currentEl = el
		$('.speechToTextButton').each(function(){
			if ($(this).attr('id') != id){
				$(this).hide()
			}
		})
		$(el).addClass('recording')
		var text = $(el).val();
		if (text.length > 0) {
			var final_transcript = text + " ";
		} else {
			var final_transcript = "";
		}
		this.recognition.onresult = function(event) {
			var interim_transcript = '';
			for (var i = event.resultIndex; i < event.results.length; ++i) {
				if (event.results[i].isFinal) {
					final_transcript += event.results[i][0].transcript;
					$(el).val(final_transcript)
				} else {
					interim_transcript += event.results[i][0].transcript;
					$(el).val(final_transcript + interim_transcript)

				}
			}
		}.bind(this);
		this.currentEl = el
		this.recognition.start();
	},

	checkWhenDone: function() {
		$('.speechToTextButton').each(function(){
			$(this).show()
			
		})
	},
}
module.exports = SpeechToText;


// WEBPACK FOOTER //
// ./modules/lib/interface/SpeechToText.js